import React, { Fragment } from 'react';
import Card from './Card';
import Header from './Header';

const UserManagement = (props) => (
    <Fragment>
        <Header headerName={props.headerName} />
        <div className="container-fluid mt--6">
            <div className="row">
                <div className="col-xl-12 order-xl-1">
                    <Card {...props} />
                </div>
            </div>
        </div>
    </Fragment>
);

export default UserManagement;


// WEBPACK FOOTER //
// ./src/components/Pages/Users/Management/index.js